import sdl from '@jds/react-generated-sdl/JDSTableRow';
import type { JDSTableRowProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSTableRowProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    density = 'undefined',
    columnDivider = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { density, columnDivider, ...rest },
    'JDSTableRow',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const TableRow = withLogic(Component) as React.FC<JDSTableRowProps> & {
  slotName?: string;
};

TableRow.displayName = 'TableRow';
TableRow.slotName = 'jds_table_row';

export { TableRow, type JDSTableRowProps };
